export enum DealerFilterOptions {
    Favorite = 'Favorite',
    Platform = 'Platform',
    OffPlatform = 'OffPlatform',
}
